import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { environment } from 'src/environments/environment';
import { GeneralResponse } from '../../data-models/shared.data-models';
import { ProfileMenuDto } from '../../data-models/resource.data-models';

@Injectable({
  providedIn: 'root'
})
export class ResourceDataService {

  private controllerUrl:string=`Resource/`;

  constructor(
    private baseApi:BaseApiService<any>,
  ) { }

  GetProfileMenu(): Observable<ProfileMenuDto[]> {
    return this.baseApi.Get(`${this.controllerUrl}GetProfileMenu`);
  }
}
